import {observable, action, runInAction} from 'mobx'
import auditLogsAPI from '../apis/auditLogsAPI'
import alertMessage from '../utils/alertMessage'

export default class ApplyStore {
  constructor(rootStore) {
    this.rootStore = rootStore
  }

  @observable isFetching = false
  @observable auditLogsTypeList = []
  @observable auditLogsUserList = []
  @observable auditLogsList = []
  @observable isExportLoading = false

  @action
  async getAuditLogType() {
    this.auditLogsTypeList = []
    try {
      const response = await auditLogsAPI.getAuditLogType()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsTypeList = data
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async getAuditUsers() {
    this.auditLogsUserList = []
    try {
      const response = await auditLogsAPI.getAuditUsers()
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        if (code === 0) {
          this.auditLogsUserList = data
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
      })
    }
  }

  @action
  async auditLogPage(params) {
    this.isFetching = true
    this.auditLogsList = []
    try {
      const response = await auditLogsAPI.auditLogPage(params)
      const {code, data, messageEn} = response?.data

      runInAction(() => {
        this.isFetching = false
        if (code === 0) {
          this.approverList = data?.records
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isFetching = false
      })
    }
  }

  @action
  async insertAuditLog(params) {
    try {
      const response = await auditLogsAPI.insertAuditLog(params)
      runInAction(() => {

      })
      return response.data
    } catch (err) {
      runInAction(() => {
      })
    }
  }

  @action
  async auditLogExport() {
    this.isExportLoading = true
    try {
      const response = await auditLogsAPI.auditLogExport()
      const {code, data, messageEn} = response?.data
      runInAction(() => {
        this.isExportLoading = false
        if (code === 0) {
          window.open(data, '_blank')
        } else {
          alertMessage.error('Failed！' + messageEn + '')
        }
      })
      return response?.data
    } catch (err) {
      alertMessage.error(err.message)
      runInAction(() => {
        this.isExportLoading = false
      })
    }
  }
}
